import * as yup from 'yup';
import { trimmedInputValues } from '../utils';

const stockAdjustmentValidationSchema = yup.object().shape({
    sellerPONo: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('sellerPODocNo', 'Must be exactly 15 characters', value => value.length === 15)
        .required('Please enter the seller PO doc number'),
    // piPunchNo: yup.string().required("Please select pi punch no").trim(),
    // materialId: yup.number().required("Please select material ID"),
    warehouseId: yup.number().required("Please enter warehouse"),
    currentStockQty: yup.number().when(["isPositiveAdjustment"], {
        is: false,
        then : () => yup.number().required('current stock quantity is required'),
        otherwise: () => yup.number().nullable()
    }),
    inputQty: yup.string().required("Please enter qty").trim(),
    remarks: yup.string().required("Please enter remarks").trim(),
    moveDate: yup.date().required('Please select date'),
})

const newStockAdjustmentValidationSchema = yup.object().shape({
    warehouseId: yup.number().required("Please enter warehouse"),
    materialId: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('materialId', 'Must be at least 5 characters', value => value.length > 5)
        .required("Please enter material ID"),
    remarks: yup.string().required("Please enter remarks").trim(),
    moveDate: yup.date().required('Please select date'),
})

const createSellerDebitNoteSchema = yup.object().shape({
    sellerPODocNo: yup.string()
    .transform((value) => trimmedInputValues(value))
    .test('sellerPODocNo', 'Must be exactly 15 characters', value => value.length === 15)
    .required('Please enter the seller PO doc number'),
    sellerPIPunchId: yup.number().required("Please enter PI Punch"),
    // warehouseId: yup.number().required("Please enter warehouse"),
})

const processRejectedStockValidationSchema = yup.object().shape({
    warehouseId: yup.number().required("Please enter warehouse"),
    crediNoteDocNo: yup.number().required("Please select credit note"),
    remarks: yup.string().required("Please enter remarks").trim()
})

const releaseClientHoldValidationSchema = yup.object().shape({
    warehouseId: yup.number().required("Please enter warehouse"),
    crediNoteDocNo: yup.number().required("Please select credit note")
})

const processCreditNoteValidationSchema = yup.object().shape({
    crediNoteDocNo: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('crediNoteDocNo', 'Must be greater than 10 characters', value => value.length > 10)
        .required('Please enter the buyer credit note doc number'),
    materialId: yup.number().required("Please select material ID"),
    creditNoteQty: yup.number().required("Please enter credit note quantity"),
    processedQty: yup.string().required("Please enter qty").trim(),
    remarks: yup.string().required("Please enter remarks").trim()
})

const creditNoteProductsSchema = yup.array().of(
    yup.object().shape({
        materialId: yup.number().required("Please select material ID"),
        processingType: yup.number().required("Please select processing ID")
    })
)

const stockTransferValidationSchema = yup.object().shape({
    materialId: yup.number().required("Please select material ID"),
    currentWarehouseId: yup.number().required("Please enter warehouse"),
    targetWarehouseId: yup.number().required("Please enter warehouse"),
    targetWarehouseId: yup.number().required("Please enter warehouse"),
    remarks: yup.string().required("Please enter remarks").trim()
})

const scrapToSmartValidationSchema = yup.object().shape({
    materialId: yup.number().required("Please select material ID"),
    warehouseId: yup.number().required("Please enter warehouse"),
    remarks: yup.string().required("Please enter remarks").trim()
})


const stockAdjustmentInitialValues = {
	sellerPONo: null,
    sellerPOItemQty: null,
    sellerPIPunchId: null,
    sellerPOCompanyId: null,
    pmCompanyId: null,
	materialId: null,
	warehouseId: null,
    isPositiveAdjustment: true,
    currentStockQty: null,
	inputQty: null,
    GSTRate: null,
    unitPrice: null,
    moveDate: null,
    remarks: null,
}

const newStockAdjustmentInitialValues = {
    materialId: null,
    warehouseId: null,
    isPositiveAdjustment: true,
    moveDate: null,
    remarks: null,
}

const createSellerDebitNoteInitialValues = {
    sellerPODocNo: null,
    sellerPIPunchId: null,
    warehouseId: null,
    remarks: null
}

const processRejectedStockInitialValues = {
    warehouseId: null,
    crediNoteDocNo: null,
    remarks: null
}

const releaseClientHoldInitialValues = {
    warehouseId: null,
    crediNoteDocNo: null
}

const processCreditNoteInitialValues = {
    crediNoteDocNo: null,
    materialId: null,
    creditNoteQty: null,
    processedQty: null,
    remarks: null
}

const stockTransferInitialValues = {
    materialId: null,
    currentWarehouseId: null,
    targetWarehouseId: null,
    remarks: null,
}

const scrapToSmartInitialValues = {
    materialId: null,
    warehouseId: null,
    remarks: null
}

export {
    releaseClientHoldValidationSchema,
    releaseClientHoldInitialValues,
    stockAdjustmentValidationSchema, 
    stockAdjustmentInitialValues, 
    newStockAdjustmentInitialValues,
    newStockAdjustmentValidationSchema,
    processRejectedStockInitialValues, 
    processRejectedStockValidationSchema, 
    processCreditNoteInitialValues, 
    processCreditNoteValidationSchema,
    creditNoteProductsSchema,
    createSellerDebitNoteSchema,
    createSellerDebitNoteInitialValues,
    stockTransferInitialValues,
    stockTransferValidationSchema,
    scrapToSmartInitialValues,
    scrapToSmartValidationSchema
}